var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11V8.16998C8 6.07998 9.53 4.21998 11.61 4.01998C13.83 3.80998 15.73 5.41998 15.97 7.52998C16 7.78998 16.2 7.99998 16.47 7.99998H17.47C17.76 7.99998 18 7.75998 17.97 7.46998C17.69 4.15998 14.69 1.60998 11.21 2.04998C8.19 2.43998 6 5.15998 6 8.20998V11H4.5C4.22 11 4 11.22 4 11.5V21.5C4 21.78 4.22 22 4.5 22H19.5C19.78 22 20 21.78 20 21.5V11.5C20 11.22 19.78 11 19.5 11H8ZM18 20H6V13H18V20Z",
    fill: "#547089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3399 16.7999V18.0399C11.3399 18.1399 11.4199 18.2299 11.5299 18.2299H12.4699C12.5699 18.2299 12.6599 18.1499 12.6599 18.0399V16.7999C12.8499 16.6599 12.9999 16.4599 13.0699 16.2399C13.1399 16.0099 13.1499 15.7699 13.0699 15.5399C12.9999 15.3099 12.8499 15.1199 12.6599 14.9799C12.4699 14.8399 12.2399 14.7599 11.9999 14.7599C11.7599 14.7599 11.5299 14.8399 11.3399 14.9799C11.1499 15.1199 10.9999 15.3199 10.9299 15.5399C10.8599 15.7699 10.8599 16.0099 10.9299 16.2399C10.9999 16.4699 11.1499 16.6599 11.3399 16.7999Z",
    fill: "#547089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboUnlock);
export default __webpack_public_path__ + "static/media/FBOUnlock.2aab827b3ec07947588ac6a27e0a901f.svg";
export { ForwardRef as ReactComponent };